var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 585,
    height: 131,
    viewBox: "0 0 585 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.58 43.77C52.58 51.68 45.7 58.12 37.23 58.12C28.77 58.12 21.89 51.68 21.89 43.77V37.53H8.38V43.77C8.38 59.14 21.32 71.64 37.24 71.64C53.15 71.64 66.1 59.14 66.1 43.77V37.53H52.58V43.77Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.67 9.63H49.66V26.99H65.67V9.63Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.34 9.63H8.33002V26.99H24.34V9.63Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M291.81 66.34H343.89V50.33H291.81C291.65 50.33 291.51 50.2 291.51 50.03V28.06H343.89V12.06H275.5V50.03C275.5 59.02 282.82 66.34 291.81 66.34Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.91 32.49H94.92V9.1H78.91V91.15H94.92V48.5H107.91V91.15H123.92V9.1H107.91V32.49Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M238.24 9.1H222.23V66.64H238.24V43.96H257.7V27.95H238.24V9.1Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M517.7 49.18H533.71V26.84C533.71 18.69 527.08 12.06 518.93 12.06H479.12V28.07H517.7V49.18Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M564.87 9.1H548.86V79.29H564.87V43.96H581V27.95H564.87V9.1Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M513.49 102.68V81.68H497.48V102.68C497.48 111.62 504.75 118.89 513.69 118.89H565.58V102.88H513.69C513.58 102.88 513.49 102.79 513.49 102.68Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M214.6 73.28C200.06 73.28 188.24 85.11 188.24 99.64C188.24 114.18 200.06 126 214.6 126C229.13 126 240.96 114.17 240.96 99.64C240.96 85.11 229.14 73.28 214.6 73.28ZM214.6 110C208.89 110 204.25 105.35 204.25 99.65C204.25 93.94 208.89 89.3 214.6 89.3C220.31 89.3 224.95 93.94 224.95 99.65C224.96 105.35 220.31 110 214.6 110Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M318.75 75.89H302.74V97.71H271.49V113.72H350V97.71H318.75V75.89Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M443.35 27.95H424.65V43.96H443.35V79.29H459.36V9.1H443.35V27.95Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M539.66 57.35H506.11V42.21H490.56V57.35H475.4V72.91H539.66V57.35Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M390.61 11.08C387.2 11.08 384.11 12.82 382.35 15.73L355.21 60.39L368.89 68.7L390.61 32.96L412.33 68.7L426.01 60.39L398.88 15.74C397.11 12.82 394.02 11.08 390.61 11.08Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M204.59 43.77V37.53H191.08V43.77C191.08 51.68 184.19 58.12 175.73 58.12C167.27 58.12 160.39 51.68 160.39 43.77V37.53H146.88V43.77C146.88 59.14 159.83 71.64 175.74 71.64C191.65 71.63 204.59 59.13 204.59 43.77Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M204.17 9.63H188.16V26.99H204.17V9.63Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M162.84 9.63H146.83V26.99H162.84V9.63Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M52.58 37.53V43.77C52.58 51.68 45.7 58.13 37.23 58.13C28.77 58.13 21.89 51.69 21.89 43.77V37.53H52.58Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M160.39 37.53V43.77C160.39 51.68 167.27 58.13 175.73 58.13C184.19 58.13 191.08 51.69 191.08 43.77V37.53H160.39Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/배방복합커뮤니티센터_web.cda0522965b53d6809b40d4d42c87075.svg";
export { ForwardRef as ReactComponent };